import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { forwardRef, type ReactNode } from "react";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";

interface Props extends BaseProductElementProps {
  as?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
}

// @deprecated
export const Designation = forwardRef<HTMLElement, Props>((props, ref) => {
  const { clickable = true, linkProps } = props;
  const product = useProductContext(props);
  const Cmp = props.as ?? "div";

  let href: string | undefined = useProductDetailsUrl(product);
  if (linkProps?.href) {
    href = linkProps.href;
  }

  let content: ReactNode = product.designation;

  if (clickable && href) {
    content = (
      <Link href={href} variant={LinkType.SECONDARY} {...linkProps}>
        {content}
      </Link>
    );
  }

  return <Cmp className={props.className}>{content}</Cmp>;
});
